import React, { useState, useEffect, Suspense } from 'react';
import Modal from 'react-modal';
import SubscriptionDetailModal from './subscriptionDetailModal';

const ViewUser = ({ setViewUserModal, userDetails }) => {

    console.log('details',userDetails);
  const [selectedUserId, setSelectedUserId] = useState(null); // New state for storing selected user ID
  const [detailModal, setDetailModal] = useState(false);

    const formatDate = (timestamp) => {
        const date = new Date(timestamp);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${year}-${month}-${day}`;
      };

      const openDetailModal = (selectedUser) => {
        setSelectedUserId(selectedUser); // Store the selected user ID
        setDetailModal(true);
      };

    return (
        <div className='detail-page-modal'>
            <div className='modal-header'>
                <h3>User Details</h3>
                <button className='close-button' onClick={() => setViewUserModal(false)}><img src={window.getPublicUrl("/assets/images/gray-cross.svg")} alt='' /></button>

            </div>
            <div className='modal-body'>
                <ul>
                <li><strong>Name: </strong> {(userDetails.name)} </li>
                <li><strong>User Name: </strong> {(userDetails.user_name)} </li>
                <li><strong>User Email: </strong> {(userDetails.email)}</li>
                <li><strong>Joined On: </strong> {formatDate(userDetails?.createdAt) || 'NA'}</li>
                <li>
  <strong>Gender: </strong> 
  {userDetails?.gender == 0 ? "Male" : userDetails?.gender == 1 ? "Female" : "Other"}
</li>


            
                            
                {/* <li><strong>Subscriptoin Details: </strong> <span onClick={() => openDetailModal(userDetails?.subscription)}> Details</span></li> */}
                </ul>
            </div>
            <Suspense fallback={<div>Loading...</div>}>

        <Modal isOpen={detailModal} onRequestClose={() => setDetailModal(false)} contentLabel="Delete Modal" shouldCloseOnOverlayClick={false} ariaHideApp={false}
          overlayClassName={`modal-overlay subscription-detail `}
          portalClassName="add-user delete">
          <SubscriptionDetailModal setDetailModal={setDetailModal} userDetails={selectedUserId} />
        </Modal>
      </Suspense>
        </div>
    )
}

export default ViewUser